import React, { FC } from 'react';
import { Grid, Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { liveOrderCountsContext } from 'apollo/order-live-updates';
import { workflowOverviewAdministrationTemplate } from 'apollo/templates/workFlow';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import PageTitle from 'components/shared/page-title/page-title.component';
import StaticStepBox from './static-step-box.component';
import { AdministrationOverview } from 'models/workflow-step';
import { ProductionStatus } from 'models/order';

const AdministrationSection: FC = () => {
    const { t: translate } = useTranslation(['workflow', 'orders']);
    const { showBoundary } = useDenthubErrorBoundary();

    const { loading, data: result } = useQuery(workflowOverviewAdministrationTemplate, {
        context: liveOrderCountsContext,
        fetchPolicy: 'network-only',
        onError(error) {
            showBoundary(error);
        },
    });
    // Registered as a count view: an ORDER_CHANGED refresh (DD-3231) re-reads it into the cache.
    const data: AdministrationOverview = result?.workflowOverviewAdministration ?? ({} as AdministrationOverview);

    return (
        <Box>
            <PageTitle headingStyle="h2" title={translate('ADMINISTRATION')} />
            <Grid container spacing={1}>
                <Grid item md={3}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={130} />
                    ) : (
                        <StaticStepBox
                            data={data?.productionOngoing}
                            title={translate('orders:PRODUCTION_ONGOING')}
                            filters={{ production: ProductionStatus.PRODUCTION_ONGOING }}
                        />
                    )}
                </Grid>
                <Grid item md={3}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={130} />
                    ) : (
                        <StaticStepBox
                            data={data?.productionFinished}
                            title={translate('orders:PRODUCTION_FINISHED')}
                            filters={{ production: ProductionStatus.PRODUCTION_FINISHED }}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default AdministrationSection;
